import { CartModel } from '../models/Cart.model';
import { SummaryModel } from '../models/Summary.model';
import {
  LineItemDiscountModel,
  DiscountScope,
} from '../models/LineItemDiscount.model';

export const getDiscountsToAlignWith = (
  cart: CartModel,
  summary: SummaryModel,
): LineItemDiscountModel[] => {
  const lineItemDiscounts = summary.lineItemDiscounts ?? [];
  const lineItems = cart.lineItems;

  return lineItemDiscounts.filter((discountBenefit) => {
    const isSpecificItemDiscountRule =
      discountBenefit.scope === DiscountScope.LINE_ITEM;
    const hasItemsWithMoreThanOneQuantity =
      lineItems.findIndex(
        (lineItem) =>
          new Set(discountBenefit.lineItemIds).has(lineItem.id) &&
          lineItem.confirmedQuantity! > 1,
      ) > -1;
    return isSpecificItemDiscountRule && hasItemsWithMoreThanOneQuantity;
  });
};

export const checkIfItemHasDiscount = (
  lineItem: { id?: string },
  discounts: LineItemDiscountModel[],
) => {
  return (
    discounts.findIndex((discount) =>
      new Set(discount.lineItemIds).has(lineItem.id!),
    ) > -1
  );
};

export const getDiscountsValue = (
  lineItemDiscounts: LineItemDiscountModel[],
) => {
  return lineItemDiscounts.reduce((accum, discount) => {
    const amount = discount.amountOff?.amount || /* istanbul ignore next */ '0';
    return accum + Number(amount);
  }, 0);
};
